<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created() {
    console.log(this.$COMMON.token)
  }
}
</script>
<style lang="less"></style>
